(function () {
    'use strict';

    angular
    .module('szallodak-detail', []);
})();
